import AgendaViewBase from '../AgendaViewBase/AgendaViewBase';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import "../../moreCore/UI/GenericDialog/GenericDialog";
import _TabEnabledMixin from '../../moreCore/UI/Tabbing/_TabEnabledMixin';
import { HtmlHelpers, TranslationHelpers, WindowHelpers } from "../../more/Helpers";
import OE_AttendanceList from './OE_AttendanceList';
import { OrchestraBooking } from "./OE_AttendanceListTypes";

class OE_AttendanceAgenda extends compose(AgendaViewBase<any>, _TabEnabledMixin) {
	//templateString = template; // Standard verwenden...

 

    _onEmbedding(pageConfig: Tabbing.TabContainerPage, containerName: string) {
   
    }

    private _tableFormatter(cell: StaticTable.StaticTableCell<OrchestraBooking>, rowgroup: StaticTable.StaticTableRowGroup<OrchestraBooking>) {
        let entity = cell.entity;
        let name = cell.name;

        switch (cell.name) {
           
        }

        return false;        
    }
   

    private _onClick_Row(row: StaticTable.StaticTableRow<OrchestraBooking>, rowGroup: StaticTable.StaticTableRowGroup<OrchestraBooking>) {

        let entity = rowGroup.entity;

        this.openForm(entity);

    }

    openForm(entity: OrchestraBooking) {
        if (!entity) return;

        let attendanceList = new OE_AttendanceList();
        attendanceList.setup(entity);
        console.log(entity);
    }

    protected onReloadData() {
    }

   
    //-----------------------own methods -------------------------end
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        
        this.RequestManager.handleAs = "jsonWithDate";

        this.setupAgendaViewWithCallfunction(
            "Webtool_API_OrchestraEmploymentAttendanceList__GetAgendaFilterOptions",
            "Webtool_API_OrchestraEmploymentAttendanceList__GetBookingAgenda",
            lang.hitch(this, this._onClick_Row),
            this._tableFormatter,
            null
        );

        WindowHelpers.setTitles("EmploymentAttendanceList_MainTitle");      
    }
    startup(): void {
        super.startup.apply(this, arguments as any);

    }
}

export default mdsWidget(OE_AttendanceAgenda);